import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import useWindowSize from '../../hooks/useWindowSize.js';
import Carousel$1 from '../Carousel/index.js';
import carouselConfig from '../Carousel/Carousel.config.js';
import { Carousel, Columns as Columns$2 } from './Columns.styles.js';

var _excluded = ["children", "cardStyled", "extraTopSpacingForLabel", "layout", "leftAligned", "mobileCarousel", "packageCardLayout", "carousel", "boxShadow", "stacked"];
var Columns = function Columns(_ref) {
  var children = _ref.children,
    _ref$cardStyled = _ref.cardStyled,
    cardStyled = _ref$cardStyled === void 0 ? false : _ref$cardStyled,
    _ref$extraTopSpacingF = _ref.extraTopSpacingForLabel,
    extraTopSpacingForLabel = _ref$extraTopSpacingF === void 0 ? false : _ref$extraTopSpacingF,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'Default' : _ref$layout,
    _ref$leftAligned = _ref.leftAligned,
    leftAligned = _ref$leftAligned === void 0 ? true : _ref$leftAligned,
    _ref$mobileCarousel = _ref.mobileCarousel,
    mobileCarousel = _ref$mobileCarousel === void 0 ? false : _ref$mobileCarousel,
    _ref$packageCardLayou = _ref.packageCardLayout,
    packageCardLayout = _ref$packageCardLayou === void 0 ? 'Default' : _ref$packageCardLayou,
    _ref$carousel = _ref.carousel,
    carousel = _ref$carousel === void 0 ? 'No' : _ref$carousel,
    _ref$boxShadow = _ref.boxShadow,
    boxShadow = _ref$boxShadow === void 0 ? null : _ref$boxShadow,
    stacked = _ref.stacked,
    props = _objectWithoutProperties(_ref, _excluded);
  var windowSize = useWindowSize();
  var isMobile = windowSize.width < 650;
  var showMobileCarouselOnly = isMobile && mobileCarousel || carousel === 'Yes, mobile only';
  var isCarousel = isMobile && mobileCarousel || carousel && carousel !== 'No';
  if (showMobileCarouselOnly) {
    if (isMobile) {
      return /*#__PURE__*/React__default.createElement(Carousel, {
        style: {
          paddingTop: extraTopSpacingForLabel ? '32px' : '0'
        },
        cardStyled: cardStyled,
        leftAligned: leftAligned,
        mobileCarousel: mobileCarousel,
        layout: layout,
        packageCardLayout: packageCardLayout,
        extraTopSpacingForLabel: extraTopSpacingForLabel,
        isMobile: isMobile
      }, /*#__PURE__*/React__default.createElement(Carousel$1, {
        inColumns: true,
        columnsLayout: layout,
        options: carouselConfig,
        columnsLeftAligned: leftAligned,
        slideCount: children === null || children === void 0 ? void 0 : children.length,
        slides: children,
        carouselLayout: carousel
      }, children));
    }
    return /*#__PURE__*/React__default.createElement(Columns$2, _extends({
      className: "leshen-columns leshen-columns-".concat(cardStyled ? 'card' : 'default'),
      extraTopSpacingForLabel: extraTopSpacingForLabel,
      numberOfChildren: children.length,
      cardStyled: cardStyled,
      leftAligned: leftAligned,
      layout: layout,
      packageCardLayout: packageCardLayout
    }, props), children);
  }
  if (isCarousel) {
    return /*#__PURE__*/React__default.createElement(Carousel, {
      style: {
        paddingTop: extraTopSpacingForLabel ? '32px' : '0'
      },
      cardStyled: cardStyled,
      leftAligned: leftAligned,
      mobileCarousel: mobileCarousel,
      layout: layout,
      packageCardLayout: packageCardLayout,
      extraTopSpacingForLabel: extraTopSpacingForLabel,
      isMobile: isMobile
    }, /*#__PURE__*/React__default.createElement(Carousel$1, {
      inColumns: true,
      columnsLayout: layout,
      options: carouselConfig,
      columnsLeftAligned: leftAligned,
      slideCount: children === null || children === void 0 ? void 0 : children.length,
      slides: children,
      carouselLayout: carousel,
      boxShadow: boxShadow
    }, children));
  }
  return /*#__PURE__*/React__default.createElement(Columns$2, _extends({
    className: "leshen-columns leshen-columns-".concat(cardStyled ? 'card' : 'default'),
    extraTopSpacingForLabel: extraTopSpacingForLabel,
    numberOfChildren: children.length,
    cardStyled: cardStyled,
    leftAligned: leftAligned,
    layout: layout,
    packageCardLayout: packageCardLayout,
    stacked: stacked
  }, props), children);
};
var Columns$1 = Columns;

export { Columns$1 as default };
//# sourceMappingURL=index.js.map
